import { render, staticRenderFns } from "./ServicoListModal.vue?vue&type=template&id=49d44926&scoped=true"
import script from "./ServicoListModal.vue?vue&type=script&lang=js"
export * from "./ServicoListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d44926",
  null
  
)

export default component.exports